<template>
	<div class="ui card layout-card">
		<div class="image"></div>
		<div class="content">
			<div class="header">{{ layout.layoutName }}</div>
			<div class="meta">{{ layoutDimensions }}</div>
			<div class="description" v-if="layout.specialId" style="font-style: italic">Assigned as {{ layout.specialId.toLowerCase() }} flyer</div>
		</div>
		<div class="extra content ui buttons">
			<a class="ui primary icon button" data-tooltip="Go to edit Layout" :href="layoutComposerLink" v-if="canEdit"><i class="right chevron icon"></i> Edit {{ layoutTypeDisplay }}</a>
			<div class="ui floating dropdown icon button layout-actions-dropdown" :class="{ 'fluid': !canEdit }">
				<span v-if="!canEdit">Actions</span>
				<i class="dropdown icon" />
				<div class="menu layout-card-action-list"></div>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	props: {
		layout: null,
		createLayoutActions: null,
		layoutTypeDisplay: null,
		jobId: null,
		seasonId: null
	},
	computed: {
		layoutComposerLink: function() {
			var link = '/Composer.php?layoutId=' + this.layout.layoutId;

			if(this.jobId) {
				link += '&jobId=' + this.jobId;
			}
			if(this.seasonId) {
				link += '&seasonId=' + this.seasonId;
			}

			return link;
		},
		layoutDimensions: function() {
			if(!this.layout.definition.grid) {
				return '';
			}
			
			var layoutDimensions = this.layout.definition.grid.width + ' x ' + this.layout.definition.grid.height;
			return layoutDimensions;
		},
		canEdit() {
			return this.layout?.type !== 'Class';
		}
	},
	watch: {
		layout: function() {
			this.previewBox.setLayout(this.layout);

			$(this.$el).find('.layout-actions-dropdown').removeClass('loading');
		}
	},
	methods: {
		handleWindowResize: function() {
			$.setSingleTimeout.call(this, 'delayedLayoutPreviewResize', function() {
				var cardWidth = $(this.$el).width() - 2;
				this.previewBox.setPreviewWidth(cardWidth);
			}, 50);
		}
	},
	mounted: function() {
		var layoutDiv = $(this.$el).children('.image');
		var cardWidth = $(this.$el).width() - 2;

		this.previewBox = new $.LayoutPreview({
			previewBox: layoutDiv,
			previewWidth: cardWidth,
			maxHeight: 300
		});
		this.previewBox.setLayout(this.layout);

		var actionsDropdown = $(this.$el).find('.layout-actions-dropdown');
		var actionList = $(this.$el).find('.layout-card-action-list');
		if(this.createLayoutActions) {
			this.createLayoutActions(actionsDropdown, actionList, this);
		}
		actionsDropdown.dropdown({
			action: 'hide'
		});

		window.addEventListener('resize', this.handleWindowResize);
	},
	beforeDestroy: function () {
		window.removeEventListener('resize', this.handleWindowResize);
	}
};
</script>

<style scoped>
.ui.card.layout-card {
	align-self: center;
}

.ui.card.layout-card .layoutEditorPreview {
	margin: 0 auto;
}

.ui.card.layout-card > .content {
	flex-grow: 0;
}

.ui.card.layout-card .extra.content.ui.buttons {
	padding: 0;
}
.ui.card.layout-card .layout-actions-dropdown {
	flex-grow: 0;
}
</style>